import { f_prependSign, f_round, f_emptify, f_percent, f_multiply } from '@baseball-systems/formatting';

export const addToQuickNav = (mainContainerSelector, tableId, tableName) => {
  const quickNav = document.querySelector(`${mainContainerSelector} .performanceAnchors ul`);
  if (quickNav && !quickNav.querySelector(`li a[href='#${tableId}'`))
    quickNav.insertAdjacentHTML('beforeend', `<li><a href="#${tableId}">${tableName}</a></li>`);
};

const positionOrderArray = ['C', '1B', '2B', '3B', 'SS', 'LF', 'CF', 'RF'];

export const getPositionOptions = (rows) => {
  const rowsArray = rows || [];
  const positions = [...new Set(rowsArray.map((r) => r.Pos))];
  positions.sort((a, b) => positionOrderArray.indexOf(a) - positionOrderArray.indexOf(b));
  const positionOptions = [
    ...positions.map((p) => {
      return {
        val: p,
        label: p,
      };
    }),
  ];
  return { positionOptions, positions };
};

export const orderRowsByYearOrPos = (rows, selectedOrderByOption) => {
  const sortByPos = selectedOrderByOption === 'Pos';
  return rows.sort((a, b) => {
    const key = selectedOrderByOption;
    if (!a[key] || !b[key]) return a.DisplayOrder - b.DisplayOrder;
    if (sortByPos) {
      return (
        positionOrderArray.indexOf(a.Pos) - positionOrderArray.indexOf(b.Pos) ||
        b.LevId - a.LevId ||
        b.GameTypeId - a.GameTypeId ||
        a.DisplayOrder - b.DisplayOrder
      );
    }
    return (
      a[key] - b[key] ||
      b.LevId - a.LevId ||
      b.GameTypeId - a.GameTypeId ||
      positionOrderArray.indexOf(a.Pos) - positionOrderArray.indexOf(b.Pos) ||
      a.DisplayOrder - b.DisplayOrder
    );
  });
};

export const assignRowStyles = (rows, assignByPosition) => {
  const sectionMap = {};
  const key = assignByPosition ? 'Pos' : 'Section';
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    row.lastInSection = false;
    row.shadePrimary = false;
    sectionMap[row[key]] = i;
  }
  let shadeIndex = 0,
    shadePrimary = true;
  for (const arrayIndex of Object.values(sectionMap)) {
    //shade rows by position
    if (assignByPosition) {
      while (shadeIndex <= arrayIndex) {
        rows[shadeIndex++].shadePrimary = shadePrimary;
      }
    }
    shadePrimary = !shadePrimary;
    rows[arrayIndex].lastInSection = arrayIndex !== rows.length - 1;
  }
  //shade by season
  if (!assignByPosition) {
    for (const row of rows) {
      row.shadePrimary = row.Season % 2 === 0;
    }
  }
};

export const emptifyRound = (val, decimalPlaces = 1) => {
  return f_round(f_emptify(val), decimalPlaces);
};

export const emptifyRoundSign = (val, decimalPlaces = 1) => {
  const roundedValue = f_round(f_emptify(val), decimalPlaces);
  if (decimalPlaces > 0 && val !== null && !isNaN(val)) {
    const firstDigitVal = Math.abs(Math.round(val));
    const firstDigit = String(firstDigitVal)[0];
    const zeroNumStrings = ['+', '-', ''].map((sign) => `${sign}${firstDigit}.${'0'.repeat(decimalPlaces)}`);
    if (zeroNumStrings.includes(roundedValue)) {
      const sign = val > 0 ? '+' : val < 0 ? '-' : '';
      return `${sign}${firstDigit}.0`;
    }
  }
  return f_prependSign(roundedValue);
};

export const emptifyRoundPercent = (val, decimalPlaces = 1) => {
  return f_percent(f_round(f_multiply(f_emptify(val), 100), decimalPlaces));
};
